import React, { useEffect, useState } from "react";
import NewInquiryListing from "./NewInquiryListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setItems,
  setTotalItems,
  setIsTableLoading,
} from "src/redux/slices/NewInquirySlice";
import AddNewInquiryFormWrapper from "../Add/AddNewInquiryFormWrapper";
import { useGetContactListPaginationQuery } from "src/services/ContactServices";


type Props = {};

const NewInquiryListingWrapper = (props: Props) => {
  const dispatch = useDispatch();

  const [isOpenAddDialog, setIsOpenAddDialog] = useState(false);
  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.newInquiry);

  const { data, isLoading, isFetching } = useGetContactListPaginationQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["name"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setRowsPerPage(data?.pageSize || 0));
      dispatch(setPage(data?.currentPage || 0));
      dispatch(setIsTableLoading(false));
    } else {
      dispatch(setIsTableLoading(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const columns: columnTypes[] = [
    { field: "name", headerName: "Name", flex: "flex-[1_1_0%]" },
    { field: "mobile", headerName: "Mobile", flex: "flex-[1_1_0%]" },
    { field: "email", headerName: "Email", flex: "flex-[1_1_0%]" },
  ];

  return (
    <div>
      <NewInquiryListing
        columns={columns}
        rows={items}
        onAddNew={() => setIsOpenAddDialog(true)}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
      {isOpenAddDialog && (
        <AddNewInquiryFormWrapper onClose={() => setIsOpenAddDialog(false)} />
      )}
    </div>
  );
};

export default NewInquiryListingWrapper;
